import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import KeyboardControlKeyIcon from "@mui/icons-material/KeyboardControlKey";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
const MenuPage = (props) => {
  const samplePreset = [
    {
      presetName: "Productivity Sprint",
      totalTime: "70min",
      author: "N/A",
      description:
        "Clean Workspace:10,Organize pantry:15,Write weekly affirmations:15,Do a quick workout:20",

      presetTasks: [
        {
          taskName: "Clean Workspace",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Organize pantry",
          estimatedTaskTime: 20,
        },
        {
          taskName: "Write weekly affirmations",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Do a quick workout",
          estimatedTaskTime: 20,
        },
      ],
    },
    {
      presetName: "Mind Refresh",
      totalTime: "65min",
      author: "NA",
      description:
        "Practice light stretches:5,Organize a small section of your workspace:8,Sketch or doodle something relaxing:10,Write down three positive thoughts or affirmations:10,Listen to a short guided relaxation audio:15,Clean and arrange your desk supplies:8,Flip through a book or magazine for inspiration:10,Practice a quick breathing exercise:5",
      presetTasks: [
        {
          taskName: "Practice light desk stretches",
          estimatedTaskTime: 5,
        },
        {
          taskName: "Organize a small section of your workspace",
          estimatedTaskTime: 8,
        },
        {
          taskName: "Sketch or doodle something relaxing",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Write down three positive thoughts or affirmations",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Listen to a short guided relaxation audio",
          estimatedTaskTime: 15,
        },
        {
          taskName: "Clean and arrange your desk supplies",
          estimatedTaskTime: 8,
        },
        {
          taskName: "Flip through a book or magazine for inspiration",
          estimatedTaskTime: 10,
        },
        {
          taskName: "Practice a quick breathing exercise",
          estimatedTaskTime: 5,
        },
      ],
    },
    // {
    //   name: "Personal Growth Review",
    //   author: "Team abc",
    //   totalTime: "55min",
    //   description:
    //     "Write strengths and weaknesses:15,Review recent achievements:20,Identify areas to improve:20",
    // },
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div
      style={{
        padding: "1px",
        fontFamily: "Arial, sans-serif",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "400px",
          border: "1px solid #ccc",
          borderRadius: "15px",
          padding: "10px",
          background: "#f4f4f4",
        }}
      >
        {samplePreset.map((preset, index) => (
          <div
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: "10px",
              marginBottom: "10px",
              padding: "5px",
              background: "#fff",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "left",
              }}
            >
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    margin: "1px 0",
                    fontSize: "1rem",
                    textAlign: "left",
                  }}
                >
                  {preset.presetName}
                </p>
                <p
                  style={{
                    margin: "0",
                    color: "gray",
                    fontSize: "0.7rem",
                    textAlign: "left",
                  }}
                >
                  Category: Productivity
                </p>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={() => handleToggle(index)}
                  style={{
                    padding: "5px 10px",
                    // background: expandedIndex === index ? "#dc3545" : "#28a745",
                    color: "black",
                    border: "none",
                    borderRadius: "20px",
                    cursor: "pointer",
                  }}
                >
                  {expandedIndex === index ? (
                    <VisibilityOffIcon
                      style={{ fontSize: "1.1rem" }}
                    ></VisibilityOffIcon>
                  ) : (
                    <VisibilityIcon
                      style={{ fontSize: "1.1rem" }}
                    ></VisibilityIcon>
                  )}
                </button>
                <button
                  onClick={() => {
                    // props.setTaskName(preset.description);
                    props.addTasksToList(preset);
                    props.setIsMenuOn(false);
                    // console.log("Add clicked for", preset.name);
                  }}
                  style={{
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "20px",
                    cursor: "pointer",
                  }}
                >
                  {/* Use */}
                  <RocketLaunchIcon
                    style={{ fontSize: "1.1rem" }}
                  ></RocketLaunchIcon>
                </button>
              </div>
            </div>
            <div
              style={{
                maxHeight: expandedIndex === index ? "300px" : "0",
                overflow: "hidden",
                transition: "max-height 0.8s ease",
              }}
            >
              <div
                style={{
                  marginTop: "10px",
                  padding: "10px",
                  background: "#f9f9f9",
                  borderRadius: "5px",
                  textAlign: "left",
                  display: expandedIndex === index ? "block" : "none",
                }}
              >
                <div style={{ margin: "0" }}>
                  {/* Column Headers */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      borderBottom: "1px solid #ccc",
                      paddingBottom: "5px",
                      marginBottom: "5px",
                    }}
                  >
                    <span>Task Name</span>
                    <span>Time</span>
                  </div>

                  {/* Task List */}
                  {preset.description.split(",").map((item, i) => {
                    const [task, time] = item.split(":");
                    return (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "0.8rem",
                          paddingBottom: "3px",
                        }}
                      >
                        <span>{task.trim()}</span>
                        <span>{time.trim()} Min</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuPage;
